import { ADD_ARTWORK_FORM, ADD_ARTWORK_FORM_FAIL, ADD_ARTWORK_FORM_SUCCESS, ADD_PRINT_REQUEST, ADD_PRINT_REQUEST_FAIL, ADD_PRINT_REQUEST_SUCCESS, ADD_PRINT_TRANS, ADD_PRINT_TRANS_FAIL, ADD_PRINT_TRANS_SUCCESS, GET_ARTWORK_FORM, GET_ARTWORK_FORM_FAIL, GET_ARTWORK_FORM_SUCCESS, GET_CHECK_INTENT, GET_CHECK_INTENT_FAIL, GET_CHECK_INTENT_SUCCESS, GET_PRINTER_FROM_PRODUCT, GET_PRINTER_FROM_PRODUCT_FAIL, GET_PRINTER_FROM_PRODUCT_SUCCESS, GET_PRINTER_LIST, GET_PRINTER_LIST_FAIL, GET_PRINTER_LIST_SUCCESS, GET_PRINTING_REQUESTS_OWNER_ID, GET_PRINTING_REQUESTS_OWNER_ID_FAIL, GET_PRINTING_REQUESTS_OWNER_ID_SUCCESS, GET_PRINTING_REQUESTS_USER_ID, GET_PRINTING_REQUESTS_USER_ID_FAIL, GET_PRINTING_REQUESTS_USER_ID_SUCCESS, PRINT_REQUEST_TRANS, PRINT_REQUEST_TRANS_FAIL, PRINT_REQUEST_TRANS_SUCCESS, WITHDRAW_REQUEST_SELLER, WITHDRAW_REQUEST_SELLER_FAIL, WITHDRAW_REQUEST_SELLER_SUCCESS } from "./actionTypes";


export const addPrintRequest = (data, callback) => (
  {
    type: ADD_PRINT_REQUEST,
    payload: { data, callback },
  });
export const addPrintRequestSuccess = (data) => ({
  type: ADD_PRINT_REQUEST_SUCCESS,
  payload: data,
});
export const addPrintRequestFail = (error) => ({
  type: ADD_PRINT_REQUEST_FAIL,
  payload: error,
});





export const getPrinterFromProduct = (data, callback) => (
  {
    type: GET_PRINTER_FROM_PRODUCT,
    payload: { data, callback },
  });
export const getPrinterFromProductSuccess = (data) => ({
  type: GET_PRINTER_FROM_PRODUCT_SUCCESS,
  payload: data,
});
export const getPrinterFromProductFail = (error) => ({
  type: GET_PRINTER_FROM_PRODUCT_FAIL,
  payload: error,
});



export const getPrintRequestsUserId = (data, callback) => (
  {
    type: GET_PRINTING_REQUESTS_USER_ID,
    payload: { data, callback },
  });
export const getPrintRequestsUserIdSuccess = (data) => ({
  type: GET_PRINTING_REQUESTS_USER_ID_SUCCESS,
  payload: data,
});
export const getPrintRequestsUserIdFail = (error) => ({
  type: GET_PRINTING_REQUESTS_USER_ID_FAIL,
  payload: error,
});

////
export const getPrintRequestsOwnerId = (data, callback) => (
  {
    type: GET_PRINTING_REQUESTS_OWNER_ID,
    payload: { data, callback },
  });
export const getPrintRequestsOwnerIdSuccess = (data) => ({
  type: GET_PRINTING_REQUESTS_OWNER_ID_SUCCESS,
  payload: data,
});
export const getPrintRequestsOwnerIdFail = (error) => ({
  type: GET_PRINTING_REQUESTS_OWNER_ID_FAIL,
  payload: error,
});





////


export const addPrintTranasction = (data, callback) => (
  {
    type: ADD_PRINT_TRANS,
    payload: { data, callback },
  });
export const addPrintTranasctionSuccess = (data) => ({
  type: ADD_PRINT_TRANS_SUCCESS,
  payload: data,
});
export const addPrintTranasctionFail = (error) => ({
  type: ADD_PRINT_TRANS_FAIL,
  payload: error,
});




export const addArtworkForm = (data, callback) => ({
  type: ADD_ARTWORK_FORM,
  payload: { data, callback },
});
export const addArtworkFormSuccess = (data) => ({
  type: ADD_ARTWORK_FORM_SUCCESS,
  payload: data,
});
export const addArtworkFormFail = (error) => ({
  type: ADD_ARTWORK_FORM_FAIL,
  payload: error,
});


export const getArtworkForm = (data, callback) => ({
  type: GET_ARTWORK_FORM,
  payload: { data, callback },
});
export const getArtworkFormSuccess = (data) => ({
  type: GET_ARTWORK_FORM_SUCCESS,
  payload: data,
});
export const getArtworkFormFail = (error) => ({
  type: GET_ARTWORK_FORM_FAIL,
  payload: error,
});


export const getPrinterList = (data, callback) => ({
  type: GET_PRINTER_LIST,
  payload: { data, callback },
});
export const getPrinterListSuccess = (data) => ({
  type: GET_PRINTER_LIST_SUCCESS,
  payload: data,
});
export const getPrinterListFail = (error) => ({
  type: GET_PRINTER_LIST_FAIL,
  payload: error,
});




export const getCheckOutIntent = (data, callback) => ({
  type: GET_CHECK_INTENT,
  payload: { data, callback },
});
export const getCheckOutIntentSuccess = (data) => ({
  type: GET_CHECK_INTENT_SUCCESS,
  payload: data,
});
export const getCheckOutIntentFail = (error) => ({
  type: GET_CHECK_INTENT_FAIL,
  payload: error,
});

export const postWithdrawRequestSeller = (data, callback) => ({
  type: WITHDRAW_REQUEST_SELLER,
  payload: { data, callback },
});
export const postWithdrawRequestSellerSuccess = (data) => ({
  type: WITHDRAW_REQUEST_SELLER_SUCCESS,
  payload: data,
});
export const postWithdrawRequestSellerFail = (error) => ({
  type: WITHDRAW_REQUEST_SELLER_FAIL,
  payload: error,
});






export const printReqTrans = (data, callback) => ({
  type: PRINT_REQUEST_TRANS,
  payload: { data, callback },
});
export const printReqTransSuccess = (data) => ({
  type: PRINT_REQUEST_TRANS_SUCCESS,
  payload: data,
});
export const printReqTransFail = (error) => ({
  type: PRINT_REQUEST_TRANS_FAIL,
  payload: error,
});








